import { abTestsService } from '@@api/services/abTests/service';
import { aiToolsService } from '@@api/services/aiTools/service';
import { attachmentsService } from '@@api/services/attachments/service';
import { authService } from '@@api/services/auth/service';
import { breakingnewsService } from '@@api/services/breakingnews/service';
import { contentService } from '@@api/services/content/service';
import { externalContentService } from '@@api/services/externalContent/service';
import { filerepoService } from '@@api/services/filerepo/service';
import { functionsService } from '@@api/services/functions/service';
import { tickersService } from '@@api/services/liveticker/service';
import { metadataService } from '@@api/services/metadata/service';
import { newsletterService } from '@@api/services/newsletter/service';
import { notificationService } from '@@api/services/notification/service';
import { placementService } from '@@api/services/placement/service';
import { placementHistoryService } from '@@api/services/placementHistory/service';
import { releasenotesService } from '@@api/services/releasenotes/service';
import { revisionsService } from '@@api/services/revisions/service';
import { rtelementsService } from '@@api/services/rtelements/service';
import { slideshowService } from '@@api/services/slideshow/service';
import { spellcheckerService } from '@@api/services/spellChecker/service';
import { tenantService } from '@@api/services/tenant/service';
import { userPresenceService } from '@@api/services/userPresence/service';

import { defineClient } from './lib/defineClient';

export const client = defineClient({
    abTests: abTestsService,
    aiTools: aiToolsService,
    attachments: attachmentsService,
    auth: authService,
    breakingnews: breakingnewsService,
    content: contentService,
    externalContent: externalContentService,
    filerepo: filerepoService,
    functions: functionsService,
    liveticker: tickersService,
    metadata: metadataService,
    newsletter: newsletterService,
    notifications: notificationService,
    placement: placementService,
    placementHistory: placementHistoryService,
    releasenotes: releasenotesService,
    revisions: revisionsService,
    rtelements: rtelementsService,
    slideshow: slideshowService,
    spellchecker: spellcheckerService,
    tenant: tenantService,
    userPresence: userPresenceService,
});
